import _ from "lodash";
import moment from "moment";
import React, { Component } from "react";
import { Progress } from "reactstrap";
import ReactTable from "react-table";
import {
  ToggableDropdown,
  DropdownMenu,
  DropdownToggle,
  DropdownItem,
} from "./Dropdown";
import Pagination from "../../views/Pagination";
import TextFilter from "./TextFilter";
import DateFilter from "./DateFilter";
import FlagFilter from "./FlagFilter";
import * as util from "../../utils/helpers";

import IconYes from "../../../assets/images/icon_yes.svg";
import IconNo from "../../../assets/images/icon_no.svg";
import FilterDisabledImage from "../../../assets/images/filtergray.svg";
import FilterEnabledImage from "../../../assets/images/filter.svg";
import FilterCancelImage from "../../../assets/images/cancel.png";

const persistedTablesState = {};

const filterText = (filter, row) =>
  (!filter || !filter.value) ||
  (filter.value === "-" && !row.value) ||
  util.fuzzySearch(filter, row);

const filterDate = (filter, row) => {
  if (!filter || !filter.value) {
    return true;
  }

  const from = moment(filter.value.from).utc();
  const to = moment(filter.value.to).utc();
  return moment.utc(row[filter.id]).isBetween(from, to);
};

const filterFlag = (filter, row) =>
  !filter ||
  filter.value === null ||
  filter.value === undefined ||
  (filter.value === true || filter.value === "true") ===
  (row[filter.id] === true || row[filter.id] === "true");

class Table extends Component {
  constructor(props) {
    super(props);

    persistedTablesState[props.id] = persistedTablesState[props.id] || {
      showFilters: false,
      page: 0,
      pageSize: 5,
      filters: [],
      sorters: [],
      activeColumn: null,
    };

    if (!persistedTablesState[props.id].activeColumn) {
      const sorters = props.defaultSorters ? props.defaultSorters : [{
        id: props.columns[0].accessor,
        desc: false
      }];

      persistedTablesState[props.id].activeColumn = sorters[0].id;
      persistedTablesState[props.id].sorters = sorters;
    }

    this.state = {
      sorters: persistedTablesState[props.id].sorters,
      activeColumn: persistedTablesState[props.id].activeColumn,
      showFilters: persistedTablesState[props.id].showFilters,
    };

    this.table = React.createRef();

    this.persistState = this.persistState.bind(this);
    this.onWindowResize = this.onWindowResize.bind(this);
  }

  componentDidMount() {
    const { page, pageSize, filters } = persistedTablesState[this.props.id];

    this.table.current.setState({
      page,
      pageSize,
      filtered: filters,
    });

    window.addEventListener("resize", this.onWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.onWindowResize);
  }

  componentDidUpdate() {
    this.persistState();
  }

  onWindowResize() {
    this.table.current.setState({ page: 0 });
    this.persistState();
  }

  persistState(values = {}) {
    persistedTablesState[this.props.id] = {
      page: this.table.current.state.page,
      pageSize: this.table.current.state.pageSize,
      filters: this.table.current.state.filtered,
      sorters: this.state.sorters,
      activeColumn: this.state.activeColumn,
      showFilters: this.state.showFilters,
      ...values
    };
  }

  prepareColumns() {
    const { showFilters, sorters, activeColumn } = this.state;

    const toggleFilters = () => {
      if (this.state.showFilters && this.table.current.state.filtered.length !== 0) {
        this.table.current.setState({
          page: 0
        });
      }

      this.setState({ showFilters: !this.state.showFilters });

      if (!this.state.showFilters) {
        this.table.current.setState({
          filtered: [],
        });
      }
    };

    const DefaultColumnHeader = (name, id, className) => {
      const isActive = activeColumn === id;
      const sorter = _.find(sorters, { id: id });

      return (
        <div className={`table-head-outer ${className} ${isActive ? "blue-txt" : ""}`}>
          <p className="table-head">{name}</p>
          <i
            className={
              sorter && !sorter.desc ? "fa fa-caret-up" : "fa fa-caret-down"
            }
            aria-hidden="true"
          />
        </div>
      );
    };

    const FiltersColumnHeader = (
      <div
        className={showFilters ? "filter-outer" : "filter-hover"}
        onClick={() => toggleFilters()}
      >
        <img
          className="filter-icon"
          src={showFilters ? FilterEnabledImage : FilterDisabledImage}
        />
      </div>
    );

    const DateCell = (data) =>
      moment
        .utc(data.value)
        .local()
        .format(this.props.dateFormat || "MM/DD/YY hh:mm a");

    const FlagCell = (data) => (
      <div className="yesnoIcon">
        <img
          src={data.original[data.column.id] === "true" || data.original[data.column.id] ? IconYes : IconNo}
        />
      </div>
    );

    const FilterCell = (data) => {
      return (
        <div className="filterdrop-outer">
          <ToggableDropdown className="filter-dropown">
            <DropdownToggle>
              <div className="more">
                <i className="fa fa-ellipsis-h" aria-hidden="true"></i>
              </div>
            </DropdownToggle>
            <DropdownMenu>
              {this.props.actions.map((action) => (
                <DropdownItem
                  key={action.id}
                  onClick={() => this.props.onAction(action.id, data.original)}
                >
                  <div id="TooltipComponent">
                    <i className={`fa ${action.icon}`} aria-hidden="true" />
                    {action.description}
                  </div>
                </DropdownItem>
              ))}
            </DropdownMenu>
          </ToggableDropdown>
        </div>
      );
    };

    const columns = _.map(this.props.columns, (column) => ({
      Header: _.get(
        {
          text: DefaultColumnHeader(column.name, column.accessor),
          flag: DefaultColumnHeader(column.name, column.accessor, "yesno-head"),
          date: DefaultColumnHeader(column.name, column.accessor),
        },
        column.type
      ),
      Filter: _.get(
        {
          text: TextFilter,
          date: DateFilter,
          flag: FlagFilter,
        },
        column.type
      ),
      Cell:
        column.cell ||
        _.get(
          {
            date: DateCell,
            flag: FlagCell,
          },
          column.type
        ),
      accessor: column.accessor,
      filterable: column.filterable && showFilters,
      filterMethod: _.get(
        {
          text: filterText,
          date: filterDate,
          flag: filterFlag,
        },
        column.type
      ),
    }));

    columns.push({
      Header: FiltersColumnHeader,
      Filter: (
        <button onClick={toggleFilters} className="cancel-btn">
          <img src={FilterCancelImage} />
        </button>
      ),
      Cell: this.props.actions ? FilterCell : undefined,
      filterable: showFilters,
      sortable: false,
    });

    return columns;
  }

  render() {
    const setPage = (page) => {
      this.table.current.setState({ page });
      this.persistState({page});
    };

    const setPageSize = (pageSize) => {
      this.table.current.setState({ pageSize });
      this.table.current.setState({ page: 0 });
      this.persistState({pageSize});
    };

    const setSorters = (sorters, column) => {
      this.setState({
        sorters,
        activeColumn: column.id,
      });
    };

    return (
      <div>
        <ReactTable
          ref={this.table}
          className="-striped -highlight site_table"
          PaginationComponent={Pagination}
          columns={this.prepareColumns()}
          data={this.props.data}
          defaultPageSize={5}
          defaultSorted={this.state.sorters}
          getPaginationProps={() => ({
            setPageNo: (page) => setPage(page),
            setPageSize: (pageSize) => setPageSize(pageSize),
          })}
          onFilteredChange={() => setPage(0)}
          onSortedChange={(sorters, column) => setSorters(sorters, column)}
          onPageSizeChange={() => setPage(0)}
        />
      </div>
    );
  }
}

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table/Table.js